
import axios from 'axios'
import APP from '../config/app.config'

// import QS from 'qs'

const jsonInstance = axios.create({
  baseURL: APP.HTTP_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
  // transformRequest: [(data) => {
  //   data = QS.stringify(data)
  //   return data
  // }]
})
// etcInstance.defaults.headers.post[] = 'application/x-www-form-urlencoded'
// etcInstance.defaults.headers.post['X-APP-ID'] = '2'
// etcInstance.defaults.headers.post['X-APP-VER'] = APP.VERSION
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

jsonInstance.interceptors.request.use(config => {
  console.log('UtilAxios %c request  url: ' + config.url + ' => params:', 'color: red', config.data)
  return config
}, err => {
  return Promise.reject(err)
})
jsonInstance.interceptors.response.use(response => {
  if (response.status === 200 && response.data) {
    const res = response.data
    if (res.code === 0) {
      // console.log('%c response url: ' + response.config.url.replace(APP.HTTP_URL, '') + ' => success:', 'color: blue', response.data.data)
      return res.data
    }
    return Promise.reject(res)
  } else {
    return Promise.reject(new Error('request error!'))
  }
}, err => {
  return Promise.reject(err)
})

export default {jsonInstance}
